<!-- eslint-disable @angular-eslint/template/no-inline-styles -->
@if (showBulkActions()) {
  <div class="bulk-actions-container">
    <app-bulk-document-actions
      [attachments]="getFileSelectorAttachments()"
      [currentAttachmentIndex]="currentAttachmentIndex"
      [isLoadingFiles]="isLoadingFiles"
      [batch]="batchValue()"
      [bulkActionType]="bulkActionType"
      [docAreas]="areas"
      (closeBulkActionEvent)="closeBulkDocumentActions()"
      (mergeEvent)="handleSuccessfulMerge($event)"
      (updateKeyFieldsEvent)="handleBulkUpdatedocumentDetails($event)"
    ></app-bulk-document-actions>
  </div>
} @else {
  @if (isLoadingFiles) {
    <app-loading-overlay [loadingMessage]="'loadingDocuments' | translate"></app-loading-overlay>
  }
  @if (batchCompletedSuccessfully()) {
    <p-message
      class="batch-message-container"
      closable="true"
      severity="contrast"
      icon="fa-solid fa-folder-check"
      [life]="15000"
    >
      {{ 'batchCompletedMessage' | translate }}
    </p-message>
  }
  @if (reopenedBatch()) {
    <p-message
      class="batch-message-container"
      closable="true"
      severity="contrast"
      icon="fa-regular fa-folder-open"
      [life]="15000"
    >
      {{ 'batchReopenMessage' | translate }}
    </p-message>
  }
  <div
    class="doc-filing-container"
    [hidden]="!isFiling"
    [ngStyle]="{ display: isFiling ? 'flex' : 'none' }"
  >
    <ng-container>
      <app-file-selector
        [attachments]="getFileSelectorAttachments()"
        [batch]="batchValue()"
        [selectedDocumentId]="sessionService.session().selectedDocumentId"
        [currentAttachmentIndex]="currentAttachmentIndex"
        [enableBatchOptions]="enableBatchOptions"
        [isBatchCompleted]="isBatchCompleted()"
        [canCloseBatch]="true"
        [isLoadingFiles]="isLoadingFiles"
        [batchLoading]="batchLoading"
        [isAutoClassificationEnabled]="isAutoClassificationEnabled"
        [disabled]="showDocumentSplit()"
        [class.disabled]="showDocumentSplit()"
        (selectDocumentEvent)="selectDocument($event)"
        (openEditBatchEvent)="openEditBatchModal()"
        (openAddDocumentsEvent)="openAddDocumentsModal()"
        (openScanningDialogEvent)="openScanningDialog()"
        (openMergeDocumentsEvent)="openMergeDocuments()"
        (openUpdateDocumentsEvent)="openUpdateDocuments()"
        (deleteBatchEvent)="confirmDeleteBatch()"
        (closeBatchEvent)="confirmCloseBatch()"
        (closeDocumentsEvent)="restartAdHocFiling()"
      ></app-file-selector>

      @if (showDocumentSplit()) {
        <app-document-split
          [base64Content]="documents[currentAttachmentIndex]?.fileContent || ''"
          [fileName]="documents[currentAttachmentIndex]?.fileName || ''"
          [documentId]="documents[currentAttachmentIndex]?.fileId || ''"
          [tenantId]="tenantId"
          (closeSplitEvent)="closeDocumentSplit()"
          (documentSplitEvent)="handleDocumentSplit($event)"
        ></app-document-split>
      } @else {
        @if (isSelectedDocumentExpired() && docExpirationUiEnabled()) {
          <div class="expired-document-container">
            <span class="expired-document-text">{{ 'documentExpiredMessage' | translate }}</span>
            @if (showDeleteDocumentButton()) {
              <p-button
                severity="danger"
                icon="fa-solid fa-trash"
                [label]="'deleteDocument' | translate"
                (click)="cancelFileFiling()"
              ></p-button>
            }
          </div>
        } @else {
          <div
            class="document-viewer-container"
            [hidden]="isCurrentFileUnsupported"
          >
            @if (documents[currentAttachmentIndex]?.fileContent) {
              <app-document-viewer
                [base64Content]="documents[currentAttachmentIndex]?.fileContent"
                [expirationDate]="documents[currentAttachmentIndex]?.expiresOn"
                (openDocumentSplitEvent)="openDocumentSplit()"
              >
              </app-document-viewer>
            }
          </div>
          @if (isCurrentFileUnsupported) {
            <div class="unsupported-msg-container">
              <span class="unsupported-msg-text">{{ 'unsupportedFileType' | translate }}</span>
            </div>
          }
          @if (
            (isAutoClassificationEnabled &&
              documents[currentAttachmentIndex]?.classificationStarted) ||
            (!isAutoClassificationEnabled &&
              !isAutoclassificationFlagLoading &&
              documents[this.currentAttachmentIndex])
          ) {
            <div class="key-fields-container">
              <app-key-fields
                [docAreas]="areas"
                [batch]="batchValue()"
                [autoclassificationEnabled]="isAutoClassificationEnabled"
                [extractionCompleteEvent]="extractionCompleteEvent.asObservable()"
                [canFile]="!disableFileByPrivilege()"
                [showDeleteDocument]="showDeleteDocumentButton()"
                (cancelClassificationEvent)="cancelFileAutoClassification($event)"
                (reExtractDocumentEvent)="reExtractDocument($event)"
                (deleteDocumentEvent)="cancelFileFiling()"
                (exportDocumentEvent)="exportDocument($event)"
              >
              </app-key-fields>
            </div>
          }
        }
      }
    </ng-container>
  </div>
}
<p-toast
  position="bottom-right"
  key="uploadDoneToast"
  class="upload-done-toast"
>
  <ng-template
    let-message
    pTemplate="message"
  >
    <div class="toast-message-container">
      <div class="icon-container">
        <i class="fa-solid fa-circle-check"></i>
      </div>
      <div class="message-container">
        <span class="message-summary">{{ message.summary | translate }}</span>
        <span>{{ message.detail | translate }}</span>
      </div>
    </div>
  </ng-template>
</p-toast>
<p-toast
  position="bottom-right"
  key="errorToast"
  class="error-toast"
>
  <ng-template
    let-message
    pTemplate="message"
  >
    <div class="toast-message-container">
      <div class="icon-container">
        <i class="fa-solid fa-circle-exclamation"></i>
      </div>
      <div class="message-container">
        <span class="message-summary">{{ message.summary | translate }}</span>
        <span>{{ message.detail | translate }}</span>
        <span>{{ message.data || '' }}</span>
      </div>
    </div>
  </ng-template>
</p-toast>
